// Module
var code = "<script>let $ctrl</script> <section ng-if=\"$ctrl.showOverlay\" class=\"molecule-form-overlay-on-submit\"> <div class=\"molecule-form-overlay-on-submit__info-area\"> <fa-icon class=\"icon-space-right\" icon=\"spinner\" spin=\"true\"></fa-icon> <atom-text modifier=\"subheadline\">{{ $ctrl.processText }}</atom-text> </div> </section> ";
// Exports
module.exports = code;